import { render } from "./EstoqueVariavel.vue?vue&type=template&id=62dca9a4&scoped=true"
import script from "./EstoqueVariavel.vue?vue&type=script&lang=js"
export * from "./EstoqueVariavel.vue?vue&type=script&lang=js"

import "./EstoqueVariavel.vue?vue&type=style&index=0&id=62dca9a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dca9a4"]])

export default __exports__